module.exports = __webpack_public_path__ + "img/6ef8462d-7d47-4d11-b043-82d1d3e19c6a.7f006c85.png";